import $ from "jquery";

const NavigationHeader = () => {
  const currentPathname = location.pathname;

  const headerMenuItemLink = $('.header-nav__menu-item-link');
  const languageBasePath = "/" + window.shopConfig.language + "/";
  const excludedPages = [languageBasePath, '/', '/login/', '/wishlist/', '/basket/'];

  if (excludedPages.indexOf(currentPathname) === -1) {
    headerMenuItemLink.each(function () {
      if ($(this).attr('href').indexOf(currentPathname) !== -1) {
        $(this).addClass('active');
      }
    });

    if (!headerMenuItemLink.hasClass('active')) {
      $('.header-nav__menu-item--first').addClass('active');
    }
  }
}

export default NavigationHeader;